import { render, staticRenderFns } from "./CompanyType.vue?vue&type=template&id=871e9ce6&scoped=true"
import script from "./CompanyType.vue?vue&type=script&lang=js"
export * from "./CompanyType.vue?vue&type=script&lang=js"
import style0 from "./CompanyType.vue?vue&type=style&index=0&id=871e9ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871e9ce6",
  null
  
)

export default component.exports